export { LazyLoader } from './LazyLoader';
